import { api } from '..'
import { TGatewayListItem } from 'shared/types'
import { useQuery } from '@tanstack/react-query'

export const getGateway = (gatewayId: string) =>
  api
    .get<TGatewayListItem>(`/v1/lorawan/gateways/${gatewayId}`)
    .then(({ data }) => data)

export const useGetLoraGateway = (deviceId?: string) => {
  if (!deviceId) throw new Error('Missing deviceId')
  return useQuery({
    queryFn: () => getGateway(deviceId),
    queryKey: ['gateway', deviceId],
  })
}
